export default __webpack_public_path__ + "media/zurb/img/home/home-tool-helio-a36c7c1af544b2a54dcfdc48ebbdf6d5.png";